const projectId = 'blackrock-developers-wnc'
const apiKey = 'AIzaSyBKFrR3g87b_K-AmY6K73H5VscLtp9qwmg'
const documentsBase = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents`

export const MANAGED_MEDIA_PREFIX = 'firestore-media://'

type FirestoreValue = {
  stringValue?: string
  integerValue?: string
  bytesValue?: string
}

type FirestoreDocument = {
  fields?: Record<string, FirestoreValue>
}

const blobCache = new Map<string, Blob>()
const MAX_CACHED_BLOBS = 3

export function managedMediaId(reference: string) {
  if (!reference.startsWith(MANAGED_MEDIA_PREFIX)) return null
  const id = reference.slice(MANAGED_MEDIA_PREFIX.length)
  return /^[a-zA-Z0-9_-]{8,120}$/.test(id) ? id : null
}

function decodeBase64(value: string) {
  const binary = window.atob(value)
  const bytes = new Uint8Array(binary.length)
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index)
  return bytes
}

async function fetchDocument(path: string, signal?: AbortSignal) {
  const response = await fetch(`${documentsBase}/${path}?key=${apiKey}`, { signal })
  if (!response.ok) throw new Error('Media could not be loaded')
  return response.json() as Promise<FirestoreDocument>
}

export async function fetchManagedMedia(reference: string, signal?: AbortSignal) {
  const mediaId = managedMediaId(reference)
  if (!mediaId) throw new Error('Invalid managed media reference')
  const cached = blobCache.get(reference)
  if (cached) return cached

  const manifest = await fetchDocument(`siteMedia/${mediaId}`, signal)
  const contentType = manifest.fields?.contentType?.stringValue || ''
  const chunkCount = Number(manifest.fields?.chunkCount?.integerValue || 0)

  const supportedTypes = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'video/mp4',
    'video/quicktime',
    'video/webm',
  ]
  if (!supportedTypes.includes(contentType) || chunkCount < 1 || chunkCount > 320) {
    throw new Error('Invalid media manifest')
  }

  const documents: FirestoreDocument[] = []
  for (let batchStart = 0; batchStart < chunkCount; batchStart += 16) {
    const batch = await Promise.all(
      Array.from(
        { length: Math.min(16, chunkCount - batchStart) },
        (_, offset) => batchStart + offset,
      ).map((index) => fetchDocument(`siteMedia/${mediaId}/chunks/${String(index).padStart(4, '0')}`, signal)),
    )
    documents.push(...batch)
  }
  const chunks = documents.map((document) => {
    const encoded = document.fields?.data?.bytesValue
    if (!encoded) throw new Error('Media is incomplete')
    return decodeBase64(encoded)
  })

  const blob = new Blob(chunks, { type: contentType })
  if (blobCache.size >= MAX_CACHED_BLOBS) {
    const oldest = blobCache.keys().next().value
    if (oldest) blobCache.delete(oldest)
  }
  blobCache.set(reference, blob)
  return blob
}
